module.exports = __webpack_public_path__ + "img/Trial.b486f2bb.png";